import ErrorMessage from "@/errors/ErrorMessage";
import HomepageCta from "../HomepageCta";
import LearnMoreCta from "../LearnMoreCta";
import { ctaContainerCss, messageCss } from "../ViewPageError.style";

const RestrictedContentNonStudentUserError = () => {
  return (
    <ErrorMessage headline="Subscription required">
      <p css={messageCss}>
        Visit the homepage to view recommended content—or learn more about
        Newsela’s subscription options.
      </p>

      <div css={ctaContainerCss}>
        <LearnMoreCta />
        <HomepageCta />
      </div>
    </ErrorMessage>
  );
};

export default RestrictedContentNonStudentUserError;
